
<div class="container col-xxl-8 px-4 py-5 landing-content">
  <div class="row align-items-center g-5 py-5">

      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Data Processing Agreement</h1>
      <div class="row align-items-center g-5 py-5">
        <h2 class="display-5 lh-1 mb-3">1. Roles</h2>
        <p>Customer acts as the data controller (or business). GeoAstra acts as the data processor (or service provider) with respect to customer data.</p>

        <h2 class="display-5 lh-1 mb-3">2. Categories of Data</h2>
        <p>As configured by Customer, RTK Base data and related telemetry, including coordinates/metadata, timestamps, device identifiers, and account identifiers.</p>

        <h2 class="display-5 lh-1 mb-3">3. Purpose and Instructions</h2>
        <p>Processor will process customer data solely to provide, maintain, secure, and improve the Service for Customer and only in accordance with Customer’s documented instructions.</p>

        <h2 class="display-5 lh-1 mb-3">4. Retention and Deletion</h2>
        <p>Default retention is 365 days. Upon termination or written request, Processor will delete or anonymize customer data within 30 days unless retention is required by law or for security/abuse-prevention.</p>

        <h2 class="display-5 lh-1 mb-3">5. Security</h2>
        <p>Processor implements technical and organizational measures appropriate to the risk, including encryption in transit and at rest, access controls, and audit logging. For protocol versions that do not support encryption in transit (e.g., NTRIP v1), data is encrypted once received by the Service.</p>

        <h2 class="display-5 lh-1 mb-3">6. Backups and Logs</h2>
        <p>Processor does not back up customer data. Processor retains access and security audit logs for up to 365 days for security and compliance purposes.</p>

        <h2 class="display-5 lh-1 mb-3">7. Subprocessors and Transfers</h2>
        <p>Customer acknowledges that data may be stored and processed in jurisdictions where the Processor or its infrastructure operate, with reasonable safeguards consistent with applicable law.</p>

        <h2 class="display-5 lh-1 mb-3">8. Data Subject Requests</h2>
        <p>Processor will support Customer in responding to data subject requests for access, deletion, and correction in accordance with applicable law and Customer’s instructions.</p>

        <h2 class="display-5 lh-1 mb-3">9. Breach Notification</h2>
        <p>Processor will notify Customer without undue delay and no later than 7 days after becoming aware of a personal data breach impacting Customer data.</p>

        <h2 class="display-5 lh-1 mb-3">10. Return or Deletion on Termination</h2>
        <p>Upon termination or expiry of the Service, Processor will delete or anonymize customer data within 30 days unless retention is required by law or for security/abuse-prevention.</p>
      </div>

  </div>
</div>